import styled from '@emotion/styled';
import {
  css,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { colors } from 'theme/colors';

interface IStyledTableBodyRow {
  rowColor?: string;
  rowColorHover?: string;
  justifyContentHead?: string;
  showDetail?: boolean;
  isCenterTableHead?: boolean;
}

const StyledTableContainer = styled(TableContainer)`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  white-space: nowrap;
`;

const StyledTable = styled(Table)``;

const StyledTableHead = styled(TableHead)``;

const StyledTableHeadRow = styled(TableRow)`
  height: 32px;
`;

const StyledTableHeadCell = styled(TableCell)`
  padding: 0;
  border: none;

  & > div {
    height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    background-color: ${colors.primary50};
    color: ${colors.primary900};
    font-weight: 600;
    letter-spacing: 0.02em;
    padding: 6px 12px 6px 12px;
    margin-right: 1px;

    ${(props: IStyledTableBodyRow) =>
      props.justifyContentHead &&
      css`
        justify-content: ${props.justifyContentHead};
      `}
    & > h6 {
      color: ${colors.primary900};
    }
  }

  &:first-of-type > div {
    border-radius: 4px 0 0 0;
  }

  &:last-child > div {
    border-radius: 0 4px 0 0;
  }
`;
const StyledTableBody = styled(TableBody)``;

const StyledTableBodyRow = styled(TableRow, {
  shouldForwardProp(prop) {
    return prop !== 'rowColor' && prop !== 'rowColorHover';
  },
})`
  ${(props: IStyledTableBodyRow) =>
    !props.showDetail &&
    css`
      border-bottom: 1px solid ${colors.primary50};
    `}

  ${(props: IStyledTableBodyRow) =>
    props.rowColorHover &&
    css`
      &:hover {
        background-color: ${props.rowColorHover} !important;
      }
    `}

  ${(props: IStyledTableBodyRow) =>
    props.rowColor &&
    css`
      background-color: ${props.rowColor} !important;
    `}
`;

interface IStyledTableBodyCell {
  width?: string;
  minWidth?: string;
  maxWidth?: string;
}

const StyledTableBodyCell = styled(TableCell)<IStyledTableBodyCell>`
  color: ${colors.gray900};
  height: 32px;
  padding: 6px 12px;
  border: none;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  width: ${({ width }) => width};
  min-width: ${({ minWidth, width }) => minWidth || width || '110px'};
  max-width: ${({ maxWidth }) => maxWidth};
`;

const StyledDetails = styled(TableRow)`
  background-color: ${colors.primary15};
`;
const StyledTableCellDetails = styled(TableCell)`
  padding: 25px;
  width: 100%;
`;

const StyledTableCellDetailsTitle = styled(Typography)`
  padding: 0px 10px 15px 6px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.08em;
  color: ${colors.primary200};
  text-transform: uppercase;
`;

const StyledTableDetails = styled(Table)``;

const StyledTableDetailsHead = styled(TableHead)``;

const StyledTableDetailsHeadRow = styled(TableRow)`
  height: 32px;
  border-bottom: 1px solid ${colors.primary50};
`;

const StyledTableDetailsHeadCell = styled(TableCell)`
  padding: 6px 0px 6px 6px;
  border: none;

  & > div {
    height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    background-color: ${colors.primary50};
    color: ${colors.primary900};
    font-weight: 600 !important;
    letter-spacing: 0.02em;
    padding: 6px 12px 6px 12px;
    margin-right: 1px;

    ${(props: IStyledTableBodyRow) =>
      props.isCenterTableHead &&
      css`
        justify-content: center;
      `}

    ${(props: IStyledTableBodyRow) =>
      props.justifyContentHead &&
      css`
        justify-content: ${props.justifyContentHead};
      `}
    & > h6 {
      color: ${colors.primary900};
    }
  }

  &:first-of-type > div {
    border-radius: 4px 0 0 0;
  }

  &:last-child > div {
    border-radius: 0 4px 0 0;
  }
`;
const StyledTableDetailsBody = styled(TableBody)``;

const StyledTableDetailsBodyRow = styled(TableRow, {
  shouldForwardProp(prop) {
    return prop !== 'rowColor' && prop !== 'rowColorHover';
  },
})`
  border: none;

  ${(props: IStyledTableBodyRow) =>
    props.rowColorHover &&
    css`
      &:hover {
        background-color: ${props.rowColorHover} !important;
      }
    `}

  ${(props: IStyledTableBodyRow) =>
    props.rowColor &&
    css`
      background-color: ${props.rowColor} !important;
    `}
`;
const StyledTableDetailsBodyCell = styled(TableCell)<IStyledTableBodyCell>`
  color: ${colors.gray900};
  height: 32px;
  padding: 6px 0px 6px 6px;
  border: none;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth || '110px'};
  max-width: ${({ maxWidth }) => maxWidth};
`;

export {
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableHeadRow,
  StyledTableHeadCell,
  StyledTableBody,
  StyledTableBodyRow,
  StyledTableBodyCell,
  StyledDetails,
  StyledTableCellDetails,
  StyledTableCellDetailsTitle,
  StyledTableDetails,
  StyledTableDetailsHead,
  StyledTableDetailsHeadRow,
  StyledTableDetailsHeadCell,
  StyledTableDetailsBody,
  StyledTableDetailsBodyRow,
  StyledTableDetailsBodyCell,
};
